export class TicketLink{
    id: number;
    userId: number;
    ticketId: number;
    securityValue: string;
    createdDate:Date;
}